module.exports = __webpack_public_path__ + "static/media/YM12_3.0c7f54fd.jpg";